import React from 'react'

export default {
  home: 'Hello',
  switchLang: '中文',
  header: {
    button: '即刻注册',
    slogan: 'TOWER 5 – 全新住宅即将登场'
  },
  invest:<>


    <h5>由 SHAPE 倾力打造的 THE AMAZING BRENTWOOD<br/><span>TOWER 5 即将登场</span></h5>
    <p>这是您期待已久的绝佳机遇。作为大温最为瞩目的全新地标，The Amazing Brentwood 现已耀世登场。这里已为 Neighbourhood One 业主创造了超过6亿加元的价值。如今，Tower 5 即将于 Neighbourhood Two 拔地而起，您终于迎来时隔6年多后的首批住宅置业机会。</p>
  </>,
  stories: {
    card1: {
      title: <>TOWER 5：我们迄今为止的<br/>最佳地产机遇</>,
      content: '出门即达天车站，The Amazing Brentwood 商圈近在咫尺——从未有任何地段拥有如此羡煞旁人的特权。稍稍远离喧嚣的商业区，背靠壮丽群山和绝美水景，Tower 5 占据该项目最令人梦寐以求的位置，距离充满活力的 Neighbourhood One 仅数步之遥，且坐落于万众期待的 Neighbourhood Two 前排，让您尽享无遮挡美景。',
      caption: 'TOWER 5：我们迄今为止的最佳地产机遇'
    },
    card2: {
      title: <>TOWER 5：尽享便捷交通和<br/>顶级零售体验</>,
      content: '历时10年，斥资超过$12亿打造 Neighbourhood One，The Amazing Brentwood 正在改变大温都市面貌。第一期已建成令人惊艳的3栋住宅大楼，400,000平方英尺零售空间，一个集庆祝活动、艺术和文化于一体的中央广场，以及一系列精挑细选的零售商，包括卑诗省第一家 The Rec Room，还有 H&M Home、Cineplex VIP、Sephora、Nike、Adidas、Earls、Tap & Barrel、海底捞火锅、LL Bean、La Taqueria、Small Victory 面包店 和 Bella Gelateria。安家 Tower 5，住户下楼即可享受这一切缤纷精彩，以及更多即将入驻 Neighbourhood Two 的全新商店和餐厅，成为大温最火爆新地标的 VIP 贵宾。',
      caption: 'Neighbourhood One'
    },
    card3: {
      title: <>TOWER 5：极富创新的住宅设计<br/>即将揭晓</>,
      content: '因无与伦比的功能性和永不过时的经典设计闻名，SHAPE 的标志性住宅现已革新升级，旨在将您的居住体验推至全新高度。超前的先进配置和变革性的空间布局，将重新定义都市生活；住户从任何角度皆可欣赏惊艳美景，还可在10,000平方英尺的专属休闲设施内享受最高端的健身、娱乐和保健体验——SHAPE 回馈给您的生活方式，没有任何其他住宅可以比肩。',
      caption: 'SHAPE 全新厨房设计'
    }
  },
  register: {
    title: [
      '把握 TOWER 5 ',
      ' 绝佳机遇，',
      '即刻注册 。'
    ],
    form: {
      firstName: '名字*',
      lastName: '姓氏*',
      email: '电子邮箱*',
      phone: '电话号码*',
      postalCode: '邮编*',
      country: '国家',
      hearAbout: '您是如何得知我们项目的？*',
      isRealtor: '您是地产经纪吗？*',
      isRealtorEmployer: '雇主/经纪公司 *',
      isWorkingWithRealtor: '您正在与地产经纪合作吗？',
      isWorkingWithRealtorName: '地产经纪姓名',
      isWorkingWithRealtorEmail: '地产经纪电子邮箱*',
      isWorkingWithRealtorBrokerage: '地产经纪所属公司',
      isHomeownerAtTAB: '您现在是 The Amazing Brentwood 的零售商/Tower One 租户/业主吗 (请选择一项)？*',
      isTABRetailer: 'Are you a Retailer at The Amazing Brentwood?',
      isTABTenant: 'Are you a Rental Tenant at The Amazing Brentwood?',
      isTABHomeowner: 'Are you a Homeowner at The Amazing Brentwood?',
      questionSelections: {
        hearAbout: {
          id: 'answers[3038][answers]',
          options: [
            {
              value: 'Email Outreach',
              content: '电子邮件推广'
            },
            {
              value: 'Facebook',
              content: 'Facebook'
            },
            {
              value: 'Friends and Family',
              content: '家人及朋友'
            },
            {
              value: 'Instagram',
              content: 'Instagram'
            },
            {
              value: 'MLS',
              content: 'MLS网站'
            },
            {
              value: 'Online Search',
              content: '线上搜索'
            },
            {
              value: 'Print Publication',
              content: '印刷出版物'
            },
            {
              value: 'Realtor',
              content: '地产经纪'
            },
            {
              value: 'Signage/Walk- or Drive-by',
              content: '广告牌/步行或驾车经过'
            },
            {
              value: 'WeChat',
              content: '微信'
            },
            {
              value: 'Other',
              content: '其他'
            },
          ]

        },
        isRealtor: {
          id: 'agent',
          options: [
            {
              value: 'false',
              content: '不是'
            },
            {
              values: 'true',
              content: '是'
            }
          ]
        },
        isWorkingWithRealtor: {
          id: 'answers[8454][answers]',
          options: [
            {
              value: 'No',
              content: '不是'
            },
            {
              values: 'Yes',
              content: '是'
            }
          ]
        },
        isOrWorkingWithRealtor: {
          id: 'isOrWorkingWithRealtor',
          options: [
            {
              value: 'Yes, I am realtor',
              content: 'Yes, I am realtor'
            },
            {
              values: 'No, I am not a realtor',
              content: 'No, I am not a realtor'
            },
            {
              value: 'Yes, I am working with a realtor',
              content: 'Yes, I am working with a realtor'
            },
            {
              values: 'No, I am not working with a realtor',
              content: 'No, I am not working with a realtor'
            }
          ]
        },
        isHomeownerAtTAB: {
          id: 'isHomeownerAtTAB',
          options: [
            {
              value: 'No, none of the above',
              content: '以上都不是'
            },
            {
              values: 'Yes, I am retailer',
              content: '是的，我是零售商'
            },
            {
              value: 'Yes, I am a Tower One market rental tenant',
              content: '是的，我是 Tower One 租户'
            },
            {
              values: 'Yes, I am a current homeowner',
              content: '是的，我是业主'
            }
          ]
        },
        isTABRetailer: {
          id: 'answers[8553][answers]',
          options: [
            {
              value: 'No',
              content: '不是'
            },
            {
              values: 'Yes',
              content: '是'
            }
          ]
        },
        isTABTenant: {
          id: 'answers[8557][answers]',
          options: [
            {
              value: 'No',
              content: '不是'
            },
            {
              values: 'Yes',
              content: '是'
            }
          ]
        },
        isTABHomeowner: {
          id: 'answers[9501][answers]',
          options: [
            {
              value: 'No',
              content: '不是'
            },
            {
              values: 'Yes',
              content: '是'
            }
          ]
        },
        reasonForPurchase: {
          id: 'reasonForPurchase',
          options: [
            {
              value: 'Principal Residence',
              content: 'Principal Residence'
            },
            {
              values: 'Investment',
              content: 'Investment'
            },
            {
              values: 'For Family',
              content: 'For Family'
            }
          ]
        }
        ,
        numberOfHomesRequested: {
          id: 'numberOfHomesRequested',
          options: [
            {
              value: '1',
              content: '1'
            },
            {
              values: '2',
              content: '2'
            },
            {
              values: '3+',
              content: '3+'
            }
          ]
        },
        numberOfBuyers: {
          id: 'numberOfBuyers',
          options: [
            {
              value: '1',
              content: '(1) One - only me'
            },
            {
              values: '2',
              content: '(2) Two - myself and one other'
            },
            {
              values: '3',
              content: '(3) Three - myself and two others'
            },
            {
              values: '4',
              content: '(4) Four - myself and three others'
            },
            {
              values: 'unsure',
              content: 'I’m unsure at the moment'
            }
          ]
        }
        ,
        colourScheme: {
          id: 'colourScheme',
          options: [
            {
              value: '1',
              content: 'option 1'
            },
            {
              values: '2',
              content: 'option 2'
            }
          ]
        },
        homeOptionOneBeds: {
          id: 'homeOptionOneBeds',
          options: [
            {
              value: 'Studio',
              content: 'Studio'
            },
            {
              values: '1 BR',
              content: '1 BR'
            },
            {
              values: '1 BR + D',
              content: '1 BR + D'
            },
            {
              values: '2 BR',
              content: '2 BR'
            },
            {
              values: '2 BR + D',
              content: '2 BR + D'
            },
            {
              values: '3 BR',
              content: '3 BR'
            },
            {
              values: '3 BR + D',
              content: '3 BR + D'
            },
            {
              values: '4 BR ',
              content: '4 BR'
            }
          ]
        },
        isPermanentResident: {
          id: 'isPermanentResident',
          options: [
            {
              value: 'IS',
              content: 'Yes'
            },
            {
              values: 'IS NOT',
              content: 'No'
            }
          ]
        },
        isForeignEntity: {
          id: 'isForeignEntity',
          options: [
            {
              value: 'IS',
              content: 'Yes'
            },
            {
              values: 'IS NOT',
              content: 'No'
            }
          ]
        }
      },
      checkKeepMe: '我同意获取更多关于 Shape Marketing Corp. 的优先 VIP 体验和最新房产资讯，并接收来自 Shape Marketing Corp. 的相关电子推广信息。我可以随时通过电子邮件 info@shape.ca 或邮递到 3100 - 1090 Pender Street W., Box 315, Vancouver, BC, Canada V6E 0E3 取消注册。',
      submit: '提交',
      distclaimer: 'This is not an offering for sale as an offer can only be made when accompanied by a disclosure statement E.&O.E. Sales and Marketing by Shape Marketing.',
    },
  },
  footer: {
    title: <>全新展销中心和样板房即将登场</>,
    address: '4567 LOUGHEED HWY, BURNABY',
    phone: '604.563.8386',
    email: 'info@theamazingbrentwood.com',
    rental: '租赁住宅',
    shoppingCentre: '购物中心',
    privacyPolicy: '隐私政策',
    at: '@the.amazing.brentwood',
  }
};
